import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 21,
	viewBox: "0 0 21 21",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_5057_19433",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 21,
		height: 21,
		children: /* @__PURE__ */ _jsx("rect", {
			x: .0964355,
			y: .647461,
			width: 20,
			height: 20,
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_5057_19433)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.026 14.5578V6.73742C3.026 6.32311 3.1735 5.96846 3.4685 5.67346C3.7635 5.37846 4.11808 5.23096 4.53225 5.23096H15.6733C16.0876 5.23096 16.4423 5.37846 16.7373 5.67346C17.0323 5.96846 17.1798 6.32311 17.1798 6.73742V14.5578C17.1798 14.9721 17.0323 15.3268 16.7373 15.6218C16.4423 15.9168 16.0876 16.0643 15.6733 16.0643H4.53225C4.11808 16.0643 3.7635 15.9168 3.4685 15.6218C3.1735 15.3268 3.026 14.9721 3.026 14.5578ZM4.51954 14.8143H7.31433V6.48096H4.51954C4.45538 6.48096 4.39663 6.50769 4.34329 6.56116C4.28982 6.6145 4.26308 6.67325 4.26308 6.73742V14.5578C4.26308 14.622 4.28982 14.6807 4.34329 14.7341C4.39663 14.7876 4.45538 14.8143 4.51954 14.8143ZM8.56433 14.8143H11.6156V6.48096H8.56433V14.8143ZM12.8656 14.8143H15.6606C15.7246 14.8143 15.7834 14.7876 15.8368 14.7341C15.8902 14.6807 15.9168 14.622 15.9168 14.5578V6.73742C15.9168 6.67325 15.8902 6.6145 15.8368 6.56116C15.7834 6.50769 15.7246 6.48096 15.6606 6.48096H12.8656V14.8143Z",
			fill: "currentColor"
		})
	})]
});
export default SvgTable;
